import * as _ from 'lodash';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Credentials } from '../../types/credentials';
import { LoginService } from '../../services/login.service';
import { LogService } from '../../services/log.service';
import { BaseForm } from '../../interfaces/BaseForm';
import { Errors } from '../../errors/errors';
import { ErrorMessage } from '../../errors/error-message';
import { SessionStorageService } from '../../services/session-storage.service';

@Component({
  selector: 'app-login',
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html'
})
export class LoginComponent extends BaseForm implements OnInit {
  @ViewChild('username')
  usernameInput;
  credentials: Credentials;
  private LOCAL_STORAGE_KEY = 'overlayApiParams';
  isDirectAuthInProgress: boolean = false;
  showLoginForm: boolean = true;
  directAuthMessage: string = 'Authenticating, please wait...';

  constructor(
    private log: LogService,
    private sessionStorage: SessionStorageService,
    private loginService: LoginService,
  ) {
    super(log);
  }

  ngOnInit() {
    this.clear();

    this.errorHandler.setGenericMessage('Login failed. Please try again.');

    this.errorHandler.add(
      Errors.NOT_AUTHORIZED,
      new ErrorMessage(awsMessage => {
        // Expired invitation email
        if (_.includes(awsMessage, 'User account has expired')) {
          return (
            'Your invitation to login to Manifest MedEx has expired. ' +
            'Please contact your organization administrator to request a new invitation.' +
            '<br /><br />' +
            'If you are the organization administrator, please contact MX Support at support@manifestmedex.org'
          );
        }
        // Otherwise display whatever is in the AWS error
        return awsMessage;
      })
    );

    // Account may be locked out
    this.errorHandler.add(
      Errors.ACCOUNT_LOCKED_EXCEPTION,
      new ErrorMessage(message => message)
    );

    // New direct authorization code
    const authCode = this.sessionStorage.getAuthCode();
    const clientId = this.sessionStorage.getAuthClient();
        
    if (authCode && clientId) {
      this.log.trace('Found authorization_code and clientId, starting direct authentication.');
      this.isDirectAuthInProgress = true;
      this.showLoginForm = false;

      this.directAuth(authCode, clientId);
    } else {
      this.showLoginForm = true;
      this.isDirectAuthInProgress = false;
      this.log.trace('No authorization_code found, showing login form.');
    }

    this.log.trace('login form loaded');
  }

  isValid(): boolean {
    if (
      this.isSubmitInProgress ||
      !this.credentials.username ||
      !this.credentials.password
    ) {
      return false;
    }
    return true;
  }

  clear() {
    this.modifyOverlayParams()
    this.credentials = new Credentials();
    if (this.showLoginForm) {
      if (this.usernameInput) {
        this.usernameInput.nativeElement.focus();
      }
    }
  }
  submit() {
    this.isSubmitInProgress = true;
    this.loginService.initiateAuth(this.credentials, this.onErrorCallback);
  }

  //Call loginService's directAuth code
  directAuth(authCode, clientId) {
    this.isSubmitInProgress = true;
    this.loginService.directAuth(authCode,clientId,this.directAuthErrorHandler.bind(this));
  }

  directAuthErrorHandler(err: any) {
    this.isSubmitInProgress = false;
    this.directAuthMessage=err;
    
  }

  modifyOverlayParams() {
    try {
      let overlayApiParams = JSON.parse(window.localStorage.getItem(this.LOCAL_STORAGE_KEY));
      overlayApiParams.fromDate="";
      overlayApiParams.toDate="";
      overlayApiParams.programs="";
      window.localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(overlayApiParams));
      this.log.trace('stored overlayApiParams sucess->'+JSON.stringify(overlayApiParams));
    } catch {
      this.log.trace('stored overlayApiParams parse failed->');
    }
  }
}
